<div fxLayout="column" fxLayoutAlign="center center">
  <div *ngIf="!error" fxLayout="column" fxLayoutAlign="center center">
    <h3 class="logout-loading" i18n="logout|logout progress message@@logout_text_logging-out">Logging out</h3>
    <wd-apollo-spinner size="80"></wd-apollo-spinner>
  </div>
  <h3 class="wd-red" *ngIf="error" i18n="logout|Error; logout failure@@logout_error_logout-failure">Failed logging out</h3>
</div>
